import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

export const LinkStyless = styled(Link)({
  color: "inherit",
  textDecoration: "none",
  "&:focus, &:hover, &:visited, &:link, &:active": {
    textDecoration: "none",
    color: "inherit",
  },
});
